import { awsOidcSteps } from "./aws/oidc";
import type { InputField } from "./types";

export const rdsIamFields = [
  {
    kind: "input",
    label: "AWS region",
    required: true,
    placeholder: "us-east-1",
    helperText: "The AWS region containing the RDS or Aurora database.",
    target: { kind: "configuration", field: "region" },
  } as const satisfies InputField,
] as const;

export const rdsIamSteps = [
  ...awsOidcSteps,
  {
    title: "Grant database access",
    items: [
      {
        kind: "markdown",
        content:
          "Give the role `rds-db:connect` permission for this database user. The policy resource uses the database resource ID, not its name:\n\n`arn:aws:rds-db:{region}:{account ID}:dbuser:{database resource ID}/{database username}`\n\nFor Aurora, copy the resource ID from the cluster’s **Connectivity & security** tab. For RDS, use the DB instance resource ID.",
      },
    ],
  },
] as const;
